import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
const DURATION_SECONDS = 17 * 60 + 34;
const START = Date.now();
function getRemaining(): number {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  return DURATION_SECONDS - elapsed % DURATION_SECONDS;
}
export function Countdown() {
  const [remaining, setRemaining] = useState(getRemaining);
  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    label: 'Hours',
    value: hours
  }, {
    label: 'Minutes',
    value: minutes
  }, {
    label: 'Seconds',
    value: seconds
  }];
  return <div className="mx-auto w-full max-w-xl rounded-2xl border border-alert/40 bg-alert/10 px-4 py-4" data-id="element-89" data-mp="10dmxpjccud6y">
      <p className="flex items-center justify-center gap-2 text-center text-sm font-bold uppercase tracking-wide text-alert" data-id="element-90" data-mp="15a4vfz99pb9s">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-91" data-mp="xz3krx77cw89" />
        Promotional price ends in
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-92" data-mp="t095344j7nsd">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-93" data-mp="12rmyqv9sxtdl" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-94" data-mp="12solvy43e6bo">
              <span className="min-w-[72px] rounded-xl bg-ink px-2 py-2 text-center font-display text-4xl font-extrabold tabular-nums text-white sm:min-w-[84px] sm:text-5xl" data-id="element-95" data-mp="f1iwar8cnzo6">
                {String(u.value).padStart(2, '0')}
              </span>
              <span className="mt-1 text-[11px] font-semibold uppercase tracking-wider text-mist" data-id="element-96" data-mp="o0w6xn87muah">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className="pt-2 font-display text-4xl font-extrabold text-alert sm:text-5xl" data-id="element-97" data-mp="1zk8nfdqwsfq0">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}